import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

/**
 * Creates damped OrbitControls and saves the initial state so
 * reset() works correctly.
 */
export function createControls(
  camera: THREE.PerspectiveCamera,
  domElement: HTMLElement
): OrbitControls {
  const controls = new OrbitControls(camera, domElement);

  controls.enableDamping = true;
  controls.dampingFactor = 0.06;
  controls.enablePan = false; // panning disabled globally
  controls.minDistance = 1.5;
  controls.maxDistance = 15;
  controls.maxPolarAngle = Math.PI / 2 + 0.15; // allow slight below-ground peek
  controls.target.set(0, 0, 0);
  controls.update();
  controls.saveState(); // snapshot for reset()

  return controls;
}
